import React from "react";
import { Box, MenuItem } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import TableActionButton from "../../../../shared/components/tables/TableActionButton";
import { ReinviteUser, User } from "../../models/userModels";
import { useConfirmation } from "../../../../shared/components/confirmation/ConfirmationProvider";
import { menuItemStyles } from "../../styles/employees";
import PermissionGuard from "../../../../shared/components/PermissionGuard";
import { Modules, PermissionLevel } from "../../../../core/models/PermissionModels";

interface PermanentUserActionsProps {
  user: User;
  onReinviteUser: (model: ReinviteUser) => void;
  onDeleteUser: (id: string) => void;
  onChangeRole?: (user: User) => void;
  translate: (key: string, params?: any) => string;
  translateCommon: (key: string, params?: any) => string;
}

const PermanentUserActions = ({ user, onReinviteUser, onDeleteUser, onChangeRole, translate, translateCommon }: PermanentUserActionsProps) => {
  const confirm = useConfirmation();

  return (
    <Box className="flex justify-end w-full">
      <TableActionButton stopPropagation={true}>
        {onChangeRole && (
          <MenuItem
            sx={menuItemStyles}
            onClick={() => onChangeRole(user)}
          >
            <AdminPanelSettingsOutlinedIcon />
            {translate("changeRole")}
          </MenuItem>
        )}

        <MenuItem
          sx={menuItemStyles}
          onClick={() => onReinviteUser({ userId: user.id })}
          disabled={!!user.loginDate}
        >
          <MailOutlinedIcon />
          {translate("resend")}
        </MenuItem>

        <PermissionGuard module={Modules.Users} level={PermissionLevel.Admin}>
          <MenuItem
            sx={menuItemStyles}
            onClick={() =>
              confirm({
                title: translate("deleteUserTitle"),
                text: translate("deleteUserText", { userName: user.userName }),
                confirmButton: translate("deleteUserConfirm"),
                closeButton: translate("deleteUserCancel"),
                severity: "error",
                onConfirm: () => onDeleteUser(user.id)
              })
            }
          >
            <DeleteOutlinedIcon color="inherit" />
            {translateCommon("buttons.delete")}
          </MenuItem>
        </PermissionGuard>
      </TableActionButton>
    </Box>
  );
};

export default PermanentUserActions;